import client from '../api';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancel;

export const getAvailableFacilitiesService = async (params) => {
  return await client.get(`api/phones-module/available-facilities/`, {
    params,
  });
};

export const getPhonesDataService = async (params) => {
  if (cancel !== undefined) {
    cancel();
  }

  return await client.get('api/phones-module/', {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};
